import { useLocalStorage } from '@vueuse/core';
export const defaultToxprintsSettings = Object.freeze({
    OR: 3,
    PV1: 0.05,
    TP: 3,
});
export const defaultToxprintsAssayViewPreferences = Object.freeze({
    showNames: false,
    showStructures: null,
    showOtherMetrics: false,
    showEnrichedOnly: null,
    showToxprintStructures: true,
    showImages: false,
    recordsPerPage: 30,
    toxprintsPerPage: 30,
    hideChemicalsWithNoToxprints: false,
});
const LEGACY_VUEX_STORAGE_KEY = 'vuex';
const migrateLegacyToxprintsPreferences = () => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined')
        return;
    let rawLegacyStore = null;
    try {
        rawLegacyStore = window.localStorage.getItem(LEGACY_VUEX_STORAGE_KEY);
    }
    catch {
        return;
    }
    if (!rawLegacyStore)
        return;
    let parsedLegacyStore = null;
    try {
        parsedLegacyStore = JSON.parse(rawLegacyStore);
    }
    catch {
        return;
    }
    const legacyToxprints = parsedLegacyStore?.toxprints;
    if (!legacyToxprints)
        return;
    let didChange = false;
    if (legacyToxprints.toxprintsSettings && !window.localStorage.getItem('toxprints.settings')) {
        window.localStorage.setItem('toxprints.settings', JSON.stringify(legacyToxprints.toxprintsSettings));
        didChange = true;
    }
    if (legacyToxprints.toxprintsSelectedProfile != null && !window.localStorage.getItem('toxprints.selected-profile')) {
        window.localStorage.setItem('toxprints.selected-profile', legacyToxprints.toxprintsSelectedProfile);
        didChange = true;
    }
    if ('toxprintsSettings' in legacyToxprints || 'toxprintsSelectedProfile' in legacyToxprints) {
        const nextLegacyToxprints = { ...legacyToxprints };
        delete nextLegacyToxprints.toxprintsSettings;
        delete nextLegacyToxprints.toxprintsSelectedProfile;
        try {
            window.localStorage.setItem(LEGACY_VUEX_STORAGE_KEY, JSON.stringify({
                ...parsedLegacyStore,
                toxprints: nextLegacyToxprints,
            }));
            didChange = true;
        }
        catch {
            return;
        }
    }
    return didChange;
};
migrateLegacyToxprintsPreferences();
export const toxprintsSettingsPreference = useLocalStorage('toxprints.settings', { ...defaultToxprintsSettings }, { mergeDefaults: true });
export const toxprintsSelectedProfilePreference = useLocalStorage('toxprints.selected-profile', null);
export const toxprintsAssayViewPreferences = useLocalStorage('toxprints.assay-view-preferences', { ...defaultToxprintsAssayViewPreferences }, { mergeDefaults: true });
export const setToxprintsAssayViewPreference = (key, value) => {
    toxprintsAssayViewPreferences.value = {
        ...toxprintsAssayViewPreferences.value,
        [key]: value,
    };
};
export const getToxprintsAssayViewPreference = (key) => {
    return toxprintsAssayViewPreferences.value?.[key];
};
